/**
 * Traducciones al inglés (idioma por defecto). Clave = texto fuente en
 * español tal como aparece en el código o en index.html; `{nombre}` son
 * parámetros de t(). Generado y mantenido junto con i18n.ts: al añadir un
 * texto visible nuevo, añade aquí su traducción.
 */
export const EN: Record<string, string> = {
  "(mantener) alcance de ataque": "(hold) attack range",
  "(mantener) emojis": "(hold) emotes",
  "+{value} objetos": "+{value} items",
  "+{value}/nivel": "+{value}/level",
  "1 enemigo": "1 enemy",
  "1 jugador": "1 player",
  "3 a 16 letras, números o _. Será tu nombre en las partidas y el que usarán tus amigos para agregarte.": "3 to 16 letters, numbers or _. It will be your name in matches and the one your friends use to add you.",
  "3V3 · TRES LÍNEAS": "3V3 · THREE LANES",
  "3v3 · Tres líneas": "3v3 · Three lanes",
  "[EQUIPO]": "[TEAM]",
  "[Equipo]": "[Team]",
  "[TODOS]": "[ALL]",
  "A distancia": "Ranged",
  "Abanico": "Fan",
  "abanico de {deg}°": "{deg}° fan",
  "Absorbe": "Absorbs",
  "Acel. habilidad": "Ability haste",
  "Aceleración de habilidad actual: {value}.": "Current ability haste: {value}.",
  "Aceleración hab.": "Ability haste",
  "Aceptar": "Accept",
  "Activar o silenciar el sonido (M)": "Toggle sound (M)",
  "Agarre": "Grab",
  "AGREGAR": "ADD",
  "Ajustes": "Options",
  "Al bajar del 30% de vida obtienes un escudo del {value}% de tu vida máxima durante 3 s (cada 60 s).": "Dropping below 30% health grants a shield of {value}% of your max health for 3 s (every 60 s).",
  "Al matar o asistir a un héroe recuperas el {value}% de tu vida máxima.": "Killing or assisting on a hero restores {value}% of your max HP.",
  "Al matar o asistir a un héroe, tus enfriamientos restantes bajan un {value}%.": "Killing or assisting on a hero reduces your remaining cooldowns by {value}%.",
  "Ala de hielo": "Icewing",
  "Alcance": "Range",
  "Alcance de ataque": "Attack range",
  "Aliado": "Ally",
  "Aliento de fuego desde la boca ({range} u, {arc}°) durante {clips}.": "Fire breath from the mouth ({range} u, {arc}°) during {clips}.",
  "Ambiente": "Ambient",
  "AMIGOS": "FRIENDS",
  "Amigos": "Friends",
  "Amigos (F)": "Friends (F)",
  "AMIGOS · {count} en línea": "FRIENDS · {count} online",
  "Amuleto del tiempo": "Time Amulet",
  "ancho del héroe": "hero width",
  "anfitrión": "host",
  "Anillo de regeneración": "Regeneration Ring",
  "ANIMACIONES": "ANIMATIONS",
  "Animación": "Animation",
  "animación {time} · activo {from}–{to} · {range} u · empuje {knockback}": "animation {time} · active {from}–{to} · {range} u · knockback {knockback}",
  "antes de detenerse": "before stopping",
  "apuntar": "aim",
  "Arco generado en la mano durante {clips}.": "Generated bow in hand during {clips}.",
  "Arena": "Arena",
  "arma {name}": "weapon {name}",
  "Armadura": "Armor",
  "Armadura de cuero": "Leather Armor",
  "Arrastra para girar": "Drag to rotate",
  "Asesina": "Assassin",
  "Asesinatos": "Kills",
  "Asesinatos / muertes": "Kills / deaths",
  "Asesinatos / muertes ·": "Kills / deaths ·",
  "Asesino": "Assassin",
  "Aspiradora": "Gust Jar",
  "Atacable": "Attackable",
  "Atacar": "Attack",
  "ATAQUE": "ATTACK",
  "Ataque 1": "Attack 1",
  "Ataque 2": "Attack 2",
  "Ataque 3": "Attack 3",
  "Ataque a distancia": "Ranged attack",
  "Ataque básico · combo cuerpo a cuerpo": "Basic attack · melee combo",
  "Ataque básico · proyectil teledirigido": "Basic attack · homing projectile",
  "Ataque tornillo": "Screw Attack",
  "Ataques/s": "Attacks/s",
  "Atraviesa": "Pierces",
  "Aturde": "Stun",
  "Aturde (explosión)": "Stun (explosion)",
  "AZUL": "BLUE",
  "azul": "blue",
  "Aún no tienes amigos. Agrega a alguien con su nombre de usuario.": "You don't have friends yet. Add someone by their username.",
  "Barrido": "Sweep",
  "BASE": "BASE",
  "base {range} u × {mult}": "base {range} u × {mult}",
  "Bate de béisbol": "Home-Run Bat",
  "Blaster de Melee en la mano durante {clips}.": "Melee blaster in hand during {clips}.",
  "Bloque POW": "POW Block",
  "Bloquea atajos como Ctrl+W para no cerrar la partida sin querer": "Locks shortcuts like Ctrl+W so you don't close the match by accident",
  "Bob-omb": "Bob-omb",
  "Bola de fiesta": "Party Ball",
  "Bola Smash": "Smash Ball",
  "Bolsa de objetos": "Item Bag",
  "Bomba": "Bomb",
  "Bomba inteligente": "Smart Bomb",
  "Bomba sensor": "Motion-Sensor Bomb",
  "Bomba venenosa": "Poison Bomb",
  "Bombardero": "Bomber",
  "Botas": "Boots",
  "BOTAS": "BOOTS",
  "Botas aladas": "Winged Boots",
  "Botas blindadas": "Armored Boots",
  "Botas sigilosas": "Stealth Boots",
  "Botas veloces": "Swift Boots",
  "Botín": "Loot",
  "Build recomendada · {role}": "Recommended build · {role}",
  "BÁSICO": "BASIC",
  "Básicos": "Basic",
  "Cabeza de Medusa": "Medusa Head",
  "Cada ataque básico reduce {value} s los enfriamientos de Q, W y E.": "Each basic attack reduces Q, W and E cooldowns by {value} s.",
  "cada {every} durante {total}": "every {every} for {total}",
  "Caja de madera": "Crate",
  "Caja metálica": "Metal Box",
  "Cambiar a {team}": "Switch to {team}",
  "Cancelar": "Cancel",
  "Caparazón amarillo": "Yellow Shell",
  "Caparazón de Koopa": "Koopa Shell",
  "Caparazón de pinchos": "Spiny Shell",
  "Caparazón rojo": "Red Shell",
  "Caparazón verde": "Green Shell",
  "Captura": "Capture",
  "Carga de espada": "Sword charge",
  "Cargando modelos…": "Loading models…",
  "Cargando {name}…": "Loading {name}…",
  "Cargando…": "Loading…",
  "Cargas": "Charges",
  "Cañón de cocos": "Coconut Gun",
  "cerrada": "closed",
  "Cerrar": "Close",
  "Cerrar (Esc)": "Close (Esc)",
  "Cerrar (I)": "Close (I)",
  "Cerrar (O)": "Close (O)",
  "Cerrar el juego": "Quit game",
  "Champiñón venenoso": "Poison Mushroom",
  "chat": "chat",
  "Chat": "Chat",
  "CHAT DE LA SALA": "ROOM CHAT",
  "clic en enemigo: perseguir y atacar": "click an enemy: chase and attack",
  "Clip del modelo sin uso en el juego": "Model clip not used in game",
  "Cohete": "Firework",
  "Colmillo vampírico": "Vampire Fang",
  "Combinar: {gold} de oro": "Combine: {gold} gold",
  "Combo": "Combo",
  "Combo de tres golpes; el tercero es más fuerte.": "Three-hit combo; the third hit is stronger.",
  "Comida": "Food",
  "Compartir": "Share",
  "Comprar {item}": "Buy {item}",
  "Con objetos recomendados": "With recommended items",
  "con un nombre aleatorio (un animal en inglés y 4 números, p. ej. Fox4821).": "with a random name (an animal and 4 digits, e.g. Fox4821).",
  "Conectando con el servidor de amigos…": "Connecting to the friends server…",
  "Conectando…": "Connecting…",
  "CONFIGURACIÓN": "SETTINGS",
  "Configuración": "Settings",
  "Contenedor de corazón": "Heart Container",
  "Continuar": "Resume",
  "Continuar (P)": "Resume (P)",
  "Contra bots o entrenamiento": "Against bots or training",
  "Contraseña": "Password",
  "Controles": "Controls",
  "Copiar": "Copy",
  "Copiar código": "Copy code",
  "Copiar enlace": "Copy link",
  "Copias fantasma al moverse durante {clips}.": "Afterimages while moving during {clips}.",
  "Corazón de piedra": "Stone Heart",
  "Correr": "Run",
  "Coste de la build": "Build cost",
  "Crea una sala o únete a la de un amigo": "Create a room or join a friend's",
  "CREAR CUENTA": "SIGN UP",
  "Crear cuenta": "Sign up",
  "CREAR SALA": "CREATE ROOM",
  "Cristal de vida": "Life Crystal",
  "CUENTA": "ACCOUNT",
  "Cuerpo a cuerpo": "Melee",
  "Cuánto se adelanta la cámara hacia el cursor y lo rápido que se desplaza al acercarlo a los bordes.": "How far the camera leads toward the cursor and how fast it pans when you move it to the edges.",
  "Cámara bloqueada": "Camera locked",
  "Cámara libre": "Free camera",
  "CÁMARA LIBRE": "FREE CAMERA",
  "cámara libre": "free camera",
  "cámara libre/bloqueada": "free/locked camera",
  "Cápsula": "Capsule",
  "Código de la sala": "Room code",
  "Código de sala": "Room code",
  "Código o enlace de sala": "Room code or link",
  "código {code}": "code {code}",
  "Daga sombría": "Shadow Dagger",
  "Daga venenosa": "Poison Dagger",
  "Daño": "Damage",
  "Daño a estructuras": "Damage to structures",
  "Daño a héroes": "Damage to heroes",
  "Daño a minions": "Damage to minions",
  "daño antes de perder vida": "damage before losing health",
  "daño antes de perder vida (+{value} por nivel)": "damage before losing HP (+{value} per level)",
  "Daño de ataque": "Attack damage",
  "Daño del combo": "Combo damage",
  "Daño por golpe": "Damage per hit",
  "Daño por proyectil": "Damage per projectile",
  "daño puro": "true damage",
  "Daño total": "Total damage",
  "de la vida que le falta al objetivo": "of the target's missing health",
  "definitiva": "ultimate",
  "del daño recibido tras armadura": "of the damage taken after armor",
  "Demasiados intentos. Espera unos minutos.": "Too many attempts. Wait a few minutes.",
  "Demolición": "Demolition",
  "Derrota": "Defeat",
  "Descarga": "Discharge",
  "Desconectado": "Offline",
  "Detonar": "Detonate",
  "Devuelve el {value}% del daño que recibes de héroes y minions.": "Returns {value}% of the damage you take from heroes and minions.",
  "Disparo a distancia; el tercer tiro del combo es más fuerte.": "Ranged shot; the third shot of the combo is stronger.",
  "Disparo {n}": "Shot {n}",
  "Distancia": "Distance",
  "Duración": "Duration",
  "durante el lanzamiento": "during the cast",
  "Efectos": "Effects",
  "EFECTOS VISUALES": "VISUAL EFFECTS",
  "Ejecución con objetivo": "Targeted execute",
  "El cuerpo brilla en llamas durante {clips}.": "The body glows with flames during {clips}.",
  "El daño es antes de la armadura del objetivo.": "Damage is before the target's armor.",
  "El nombre de usuario debe tener entre {min} y {max} caracteres": "Usernames must be {min} to {max} characters long",
  "El servidor no respondió": "The server did not respond",
  "El tercer golpe de tu combo básico inflige un {value}% más de daño.": "The third hit of your basic combo deals {value}% more damage.",
  "Elige cómo quieres jugar": "Choose how you want to play",
  "Eliminar amigo": "Remove friend",
  "Embestida": "Dash",
  "Emboscada": "Ambush",
  "Emojis": "Emotes",
  "EMPEZAR": "START",
  "EMPEZAR PARTIDA": "START MATCH",
  "Empuje": "Knockback",
  "En bucle": "Loop",
  "En bucle durante toda la acción: {clips}.": "Looped for the whole action: {clips}.",
  "En el aire": "In the air",
  "En el menú": "In the menu",
  "En línea": "Online",
  "En partida": "In a match",
  "EN PARTIDA": "IN MATCH",
  "En una sala": "In a room",
  "Enemigo": "Enemy",
  "Enfriamiento": "Cooldown",
  "Enter chat · Shift+Enter equipo": "Enter chat · Shift+Enter team",
  "Entrar": "Log in",
  "ENTRAR AL ENTRENAMIENTO": "START TRAINING",
  "Entrarás como": "You'll join as a",
  "Entre golpes": "Between hits",
  "ENTRENAMIENTO": "TRAINING",
  "Entrenamiento": "Training",
  "ENVIADAS": "SENT",
  "ENVIAR": "SEND",
  "Equipo azul": "Blue team",
  "Equipo por defecto (3v3)": "Default team (3v3)",
  "Equipo rojo": "Red team",
  "EQUIPO {team}": "{team} TEAM",
  "EQUIPOS": "TEAMS",
  "Error cargando recursos": "Error loading assets",
  "Es el nombre de tu cuenta": "It's your account name",
  "Esa solicitud ya no existe": "That request no longer exists",
  "Escribe el código de la sala": "Enter the room code",
  "Escribe el nombre de usuario de tu amigo": "Enter your friend's username",
  "Escribe tu usuario y tu contraseña": "Enter your username and password",
  "Escribe un mensaje y pulsa Enter": "Type a message and press Enter",
  "Escribe un nombre de usuario": "Enter a username",
  "Escudo": "Shield",
  "Ese equipo está completo": "That team is full",
  "Ese nombre de usuario ya existe": "That username is already taken",
  "Espada corta": "Short Sword",
  "Espada láser": "Beam Sword",
  "Espada sangrienta": "Blood Sword",
  "Espadachín": "Swordsman",
  "Espera un momento antes de volver a invitarle": "Wait a moment before inviting them again",
  "ESPERANDO AL ANFITRIÓN…": "WAITING FOR THE HOST…",
  "Estado": "State",
  "ESTADÍSTICAS": "STATS",
  "Estadísticas del personaje": "Character stats",
  "Estás en la tienda": "You're at the shop",
  "Estás en la tienda · clic derecho para comprar": "You are at the shop · right-click to buy",
  "Estás en la tienda · toca un objeto y pulsa comprar": "You are at the shop · tap an item, then Buy",
  "Explosión": "Explosion",
  "explota antes de tiempo": "explodes early",
  "Fiesta": "Party",
  "fijar enemigo": "lock enemy",
  "Filo de energía": "Energy Edge",
  "Fin de la partida": "Match over",
  "FIN DE LA PARTIDA": "MATCH OVER",
  "FINAL": "FINAL",
  "Flecha": "Arrow",
  "Flipper": "Flipper",
  "Flor de fuego": "Fire Flower",
  "Flor de hielo": "Ice Flower",
  "Freezie": "Freezie",
  "fuera de combate": "out of combat",
  "Ganó el equipo azul": "Blue team wins",
  "Ganó el equipo rojo": "Red team wins",
  "Garrote de mineral": "Ore Club",
  "Gira el teléfono para jugar en horizontal": "Rotate your phone to play in landscape",
  "Girar solo": "Auto-rotate",
  "Giro": "Turn",
  "Golpe": "Strike",
  "Golpe final": "Finishing Blow",
  "Golpe {n}": "Hit {n}",
  "Golpes": "Hits",
  "Grebas de batalla": "Battle Greaves",
  "Guantes ágiles": "Agile Gloves",
  "Habilidad E": "Ability E",
  "Habilidad Q": "Ability Q",
  "Habilidad R": "Ability R",
  "Habilidad W": "Ability W",
  "Habilidad {key}": "Ability {key}",
  "HABILIDADES": "ABILITIES",
  "habilidades": "abilities",
  "Habilidades, animaciones y estadísticas": "Abilities, animations and stats",
  "Habilidades, animaciones y estadísticas de cada héroe": "Each hero's abilities, animations and stats",
  "hacia el cursor": "toward the cursor",
  "Has llegado al máximo de {max} amigos": "You've reached the limit of {max} friends",
  "Hay {count} jugadores: no caben en {size}": "There are {count} players: they don't fit in {size}",
  "Hoja del héroe": "Hero's Blade",
  "Ida y vuelta al servidor": "Round trip to the server",
  "Idioma": "Language",
  "Idioma / Language": "Language / Idioma",
  "ignora la armadura": "ignores armor",
  "Ignorar": "Ignore",
  "Impacto": "Impact",
  "Imparable": "Unstoppable",
  "Infliges un {value}% más de daño a enemigos por debajo del 30% de vida.": "You deal {value}% more damage to enemies below 30% HP.",
  "Infliges un {value}% más de daño a héroes con más del 80% de vida.": "You deal {value}% more damage to heroes above 80% health.",
  "Infliges un {value}% más de daño a los héroes.": "You deal {value}% more damage to heroes.",
  "Infliges un {value}% más de daño a los minions.": "You deal {value}% more damage to minions.",
  "Infliges un {value}% más de daño a torres y nexos.": "You deal {value}% more damage to towers and nexuses.",
  "Inicia sesión": "Log in",
  "INICIAR SESIÓN": "LOG IN",
  "Iniciar sesión": "Log in",
  "interrumpe y bloquea": "interrupts and locks",
  "Invencible": "Invincible",
  "Inventario": "Inventory",
  "Inventario lleno": "Inventory full",
  "Inventario lleno: completa un objeto o vende otro": "Inventory full: complete an item or sell one",
  "Inventario lleno: vende un objeto para comprar otro": "Inventory full: sell an item to buy another",
  "Invitación enviada a {name}": "Invite sent to {name}",
  "invitado": "guest",
  "Invitar": "Invite",
  "Invulnerable": "Invulnerable",
  "Jonrón": "Home Run",
  "Jugador": "Player",
  "Jugando como invitado": "Playing as guest",
  "Jugando offline": "Playing offline",
  "JUGAR OFFLINE": "PLAY OFFLINE",
  "JUGAR ONLINE": "PLAY ONLINE",
  "La contraseña debe tener al menos {min} caracteres": "Passwords must be at least {min} characters long",
  "La contraseña no puede pasar de {max} caracteres": "Passwords cannot be longer than {max} characters",
  "La partida está llena": "The match is full",
  "La sala está llena": "The room is full",
  "La sesión caducó. Inicia sesión de nuevo.": "Your session expired. Please log in again.",
  "La tenacidad del objetivo reduce el aturdimiento.": "The target's tenacity reduces the stun.",
  "Lanzamiento": "Cast time",
  "Las contraseñas no coinciden": "The passwords don't match",
  "Latencia al servidor: {ms} ms": "Server latency: {ms} ms",
  "LEGENDARIO": "LEGENDARY",
  "Legendarios": "Legendary",
  "Letalidad": "Lethality",
  "Libre": "Open",
  "Listo": "Done",
  "LMB · Ataque básico": "LMB · Basic attack",
  "Lo llevará un bot": "A bot will play it",
  "Los mensajes no se guardan: sólo los ve tu amigo si está en línea.": "Messages aren't saved: your friend only sees them while online.",
  "Luchador": "Fighter",
  "Marcador": "Scoreboard",
  "MARCADOR": "SCORE",
  "Martillo rompeyelmos": "Helm Breaker",
  "Master Ball": "Master Ball",
  "mejorar habilidad": "rank up ability",
  "Mensaje": "Message",
  "Mensaje a todos…": "Message everyone…",
  "Mensaje a todos… (Tab: equipo)": "Message everyone… (Tab: team)",
  "Mensaje a tu equipo…": "Message your team…",
  "Mensaje a tu equipo… (Tab: todos)": "Message your team… (Tab: all)",
  "Mensaje para {name}": "Message for {name}",
  "Midiendo latencia…": "Measuring latency…",
  "Mirada de piedra": "Stone Gaze",
  "Modelo": "Model",
  "Modelo no disponible.": "Model not available.",
  "MODO DE JUEGO": "GAME MODE",
  "Monitor burbuja": "Bubble Shield Monitor",
  "Monitor de fuego": "Fire Shield Monitor",
  "Monitor escudo": "Shield Monitor",
  "Monitor relámpago": "Lightning Shield Monitor",
  "mover · sobre enemigo: atacar": "move · on an enemy: attack",
  "Muerte": "Death",
  "Muertes": "Deaths",
  "Muñecos de práctica, sin partida": "Practice dummies, no match",
  "Música": "Music",
  "NEXO": "NEXUS",
  "Nexo": "Nexus",
  "Nivel": "Level",
  "nivel 1 · máx. rango {max}": "level 1 · max rank {max}",
  "Nivel {level}": "Level {level}",
  "niveles 6 / 11 / 16": "levels 6 / 11 / 16",
  "no": "no",
  "No estás en ninguna sala": "You're not in a room",
  "No existe ningún usuario llamado «{name}»": "There is no user called “{name}”",
  "No existe una sala con ese código": "No room with that code",
  "no lo aturden durante la carga": "can't be stunned during the charge",
  "No puedes agregarte a ti mismo": "You can't add yourself",
  "No se pudo cargar el manifiesto ({status})": "Could not load the manifest ({status})",
  "No se pudo completar": "Could not complete it",
  "No se pudo conectar": "Could not connect",
  "No se pudo conectar con el servidor": "Could not connect to the server",
  "No se pudo conectar con el servidor (¿está corriendo `npm run server`?)": "Could not connect to the server (is `npm run server` running?)",
  "Nombre de usuario": "Username",
  "Nuez Deku": "Deku Nut",
  "Objeto único: sólo uno por inventario.": "Unique item: only one per inventory.",
  "Objetos": "Items",
  "Objetos de los bots": "Bot items",
  "Omnisucción": "Omnivamp",
  "Online: la partida sigue corriendo en el servidor.": "Online: the match keeps running on the server.",
  "Orden de rangos (bots)": "Rank order (bots)",
  "Pantalla": "Display",
  "Pantalla completa": "Fullscreen",
  "para cerrar": "to close",
  "para continuar": "to resume",
  "Para todos los roles": "For every role",
  "para usar tu nombre de usuario.": "to use your username.",
  "Parachoques": "Bumper",
  "PARTIDA EN CURSO…": "MATCH IN PROGRESS…",
  "Partida en pausa": "Game paused",
  "PARTIDA RÁPIDA": "QUICK MATCH",
  "Pausa": "Pause",
  "pausa": "pause",
  "PAUSA": "PAUSE",
  "Pen. armadura": "Armor pen.",
  "Penetración": "Penetration",
  "PERSONAJES": "CHARACTERS",
  "Petición no válida": "Invalid request",
  "Pinchos": "Spikes",
  "Ping {ms} ms": "Ping {ms} ms",
  "Pistola de rayos": "Ray Gun",
  "Poción": "Potion",
  "por la embestida": "along the dash",
  "Pose procedural de arquero (brazo adelantado, mano en la mejilla).": "Procedural archer pose (bow arm forward, hand at the cheek).",
  "Pose procedural del Reflector: de frente a la cámara, en cuclillas, piernas abiertas.": "Procedural Reflector pose: facing the camera, crouched, legs apart.",
  "Protegida": "Protected",
  "Proyectil": "Projectile",
  "proyectiles": "projectiles",
  "Proyectiles": "Projectiles",
  "Puedes subirla con un punto": "You can rank it up with a point",
  "pulsa otra vez": "press again",
  "Pulsa un objeto para venderlo por el 70%": "Click an item to sell it for 70%",
  "Púas": "Barbs",
  "Quiere ser tu amigo": "Wants to be your friend",
  "Radio": "Radius",
  "radio {radius} u": "radius {radius} u",
  "Radio: {value} u": "Radius: {value} u",
  "Rango": "Rank",
  "Rango de la habilidad": "Ability rank",
  "Ratón": "Mouse",
  "Reapareces en {seconds}s": "Respawn in {seconds}s",
  "Recarga": "Recharge",
  "Receta": "Recipe",
  "Rechazar": "Decline",
  "Recibes un {value}% menos de daño de minions y torres.": "You take {value}% less damage from minions and towers.",
  "Recibir golpe": "Hit reaction",
  "recupera una cada {time} mientras le quede alguna; al gastar la última, enfriamiento completo": "regains one every {time} while any is left; spending the last one starts the full cooldown",
  "Reducción de daño: {value}": "Damage reduction: {value}",
  "Reflector hexagonal de energía durante {clips}.": "Hexagonal energy reflector during {clips}.",
  "Refleja": "Reflects",
  "Refuerzos": "Reinforcements",
  "Regeneración": "Regeneration",
  "Regeneración/s": "Regen/s",
  "Rematar un minion te da {value} de oro extra.": "Last-hitting a minion gives you {value} extra gold.",
  "Repite la contraseña": "Repeat the password",
  "Reposo": "Idle",
  "Resistencia al empuje: {value}": "Knockback resistance: {value}",
  "Restablecer": "Reset",
  "ROJO": "RED",
  "rojo": "red",
  "Ráfaga": "Barrage",
  "SALA ONLINE": "ONLINE ROOM",
  "Salas con otros jugadores": "Rooms with other players",
  "Salir": "Log out",
  "Salpicadura": "Splash",
  "Salto de {height} u con polvo durante {clips}.": "{height} u jump with dust during {clips}.",
  "Salto de {height} u con polvo y monedas durante {clips}.": "{height} u jump with dust and coins during {clips}.",
  "Se convierte en bola de fuego con estela durante {clips}.": "Turns into a fireball with a trail during {clips}.",
  "Se desbloquea": "Unlocks",
  "Se desbloquea al nivel {level}": "Unlocks at level {level}",
  "Se perdió la conexión con la sala ({detail})": "Lost the connection to the room ({detail})",
  "Se recarga el menú para aplicarlo": "The menu reloads to apply it",
  "Se usa en": "Builds into",
  "Se usa en: {keys}": "Used in: {keys}",
  "Se vende por {gold} de oro en la tienda.": "Sells for {gold} gold at the shop.",
  "Seguir como invitado": "Continue as guest",
  "Selección de personaje": "Character select",
  "Sello explosivo": "Explosive Tag",
  "Sensibilidad del ratón": "Mouse sensitivity",
  "Servidor no disponible": "Server unavailable",
  "Señor Saturno": "Mr. Saturn",
  "si todos impactan": "if all of them hit",
  "si todos los golpes conectan": "if every hit lands",
  "SILENCIADO": "MUTED",
  "silenciar sonido": "mute sound",
  "Silenciar todo": "Mute all",
  "Sin conexión con el servidor de amigos": "No connection to the friends server",
  "Sin efectos especiales en el modelo; las habilidades usan los efectos genéricos del juego.": "No special effects on the model; abilities use the game's generic effects.",
  "Sin puntos asignados; valores del rango 1": "No points assigned; rank 1 values",
  "Solicitud enviada a {name}": "Request sent to {name}",
  "Solicitud pendiente": "Request pending",
  "SOLICITUDES ({count})": "REQUESTS ({count})",
  "SONIDO": "SOUND",
  "Sonido": "Sound",
  "Sonido activado": "Sound on",
  "Sonido desactivado": "Sound off",
  "Subir habilidad (Shift+{key})": "Rank up (Shift+{key})",
  "Subir rango {key}": "Rank up {key}",
  "Superchampiñón": "Super Mushroom",
  "Superestrella": "Super Star",
  "sí": "yes",
  "sí · proyectil {kind}, velocidad {speed}": "yes · {kind} projectile, speed {speed}",
  "sólo héroes enemigos": "enemy heroes only",
  "Sólo puedes escribir a tus amigos": "You can only message your friends",
  "Sólo puedes invitar a tus amigos": "You can only invite your friends",
  "Sólo puedes llevar un par de botas.": "You can only carry one pair of boots.",
  "Sólo se compra en tu base": "You can only buy at your base",
  "Sólo se puede cambiar desde el menú principal": "You can only change it from the main menu",
  "Tab: cambiar entre todos y equipo": "Tab: switch between all and team",
  "tablero": "scoreboard",
  "TABLERO": "SCOREBOARD",
  "Tanque": "Tank",
  "Tanque de energía": "Energy Tank",
  "Te faltan {gold} de oro": "You need {gold} more gold",
  "Teletransporte": "Teleport",
  "Temblor": "Tremor",
  "Tenacidad": "Tenacity",
  "Termina o abandona la partida actual primero": "Finish or leave the current match first",
  "tienda": "shop",
  "TIENDA": "SHOP",
  "Tienda": "Shop",
  "Tienda (I)": "Shop (I)",
  "TIENDA (I)": "SHOP (I)",
  "Tienes demasiadas solicitudes pendientes": "You have too many pending requests",
  "Tipo": "Type",
  "Tirador": "Marksman",
  "Tiradora": "Marksman",
  "Todos": "All",
  "Todos los clips del modelo ({count})": "All model clips ({count})",
  "Tomate fresco": "Fresh Tomato",
  "Tomate Maxim": "Maxim Tomato",
  "Torbellino": "Whirlwind",
  "TORRE DEL NEXO": "NEXUS TOWER",
  "Torre del nexo": "Nexus tower",
  "TORRE EXTERIOR": "OUTER TOWER",
  "Torre exterior": "Outer tower",
  "TORRE INTERIOR": "INNER TOWER",
  "Torre interior": "Inner tower",
  "tras lanzarla": "after casting",
  "Trofeo ayudante": "Assist Trophy",
  "Tu amigo no está en línea": "Your friend is not online",
  "TU HÉROE": "YOUR HERO",
  "Tu nombre": "Your name",
  "Tu oro": "Your gold",
  "Tu sesión caducó. Inicia sesión de nuevo.": "Your session expired. Please log in again.",
  "Tus ataques básicos cuerpo a cuerpo infligen el {value}% del daño a los enemigos cercanos al objetivo.": "Your melee basic attacks deal {value}% of their damage to enemies near the target.",
  "Tus ataques básicos infligen además el {value}% de la vida máxima del objetivo.": "Your basic attacks also deal {value}% of the target's max HP.",
  "Tus ataques básicos infligen {value} de daño adicional.": "Your basic attacks deal {value} bonus damage.",
  "Tú": "You",
  "Un héroe por línea, torres y minions en las tres": "One hero per lane, towers and minions in all three",
  "Una sola línea: todos pelean en el centro": "A single lane: everyone fights in the middle",
  "Unira": "Unira",
  "Unirse": "Join",
  "UNIRSE": "JOIN",
  "Usa sólo letras sin tilde, números y guion bajo (_)": "Use only letters without accents, numbers and underscore (_)",
  "Usuario o contraseña incorrectos": "Wrong username or password",
  "Vara de rayos": "Beam Rod",
  "Vara estelar": "Star Rod",
  "Vas demasiado rápido: espera un momento": "You're going too fast: wait a moment",
  "Vel. ataque": "Attack speed",
  "Vel. de ataque": "Attack speed",
  "Vel. de movimiento": "Move speed",
  "Vel. movimiento": "Move speed",
  "Velocidad": "Speed",
  "velocidad de ataque × {value}": "attack speed × {value}",
  "velocidad {value}": "speed {value}",
  "Veneno": "Venom",
  "Ver animación": "Play animation",
  "Versión distinta: servidor {server}, cliente {client}. Recarga la página.": "Version mismatch: server {server}, client {client}. Reload the page.",
  "Vida": "Health",
  "Vida faltante": "Missing health",
  "Volumen general": "Master volume",
  "Volver a base": "Recall",
  "volver a base": "recall",
  "Volver al inicio": "Back to start",
  "Volver al menú": "Back to menu",
  "Volviendo a base…": "Recalling…",
  "Volviendo a base… {seconds} s": "Recalling… {seconds} s",
  "Volviendo a la sala…": "Returning to the room…",
  "Vuelve a tu base para comprar (B para volver)": "Go back to base to buy (B to recall)",
  "Ya estás en una sala": "You're already in a room",
  "Ya le enviaste una solicitud a {name}": "You already sent a request to {name}",
  "Ya llevas unas botas": "You already carry boots",
  "Ya tienes este objeto": "You already own this item",
  "{armor} de armadura": "{armor} armor",
  "{base} base · rango × {rank} · aceleración × {haste}": "{base} base · rank × {rank} · haste × {haste}",
  "{base} base × {scale}": "{base} base × {scale}",
  "{count} enemigos": "{count} enemies",
  "{count} jugadores": "{count} players",
  "{deg}° de arco": "{deg}° arc",
  "{gold} de oro": "{gold} gold",
  "{height} u de alto": "{height} u tall",
  "{hero} ya está en ese equipo: elige otro héroe primero": "{hero} is already on that team: pick another hero first",
  "{hero} ya lo eligió un compañero": "{hero} was already picked by a teammate",
  "{hero} · muerto": "{hero} · dead",
  "{hero} · nivel {level} · {relation}": "{hero} · level {level} · {relation}",
  "{hp} de vida": "{hp} health",
  "{item} — vender por {gold}": "{item} — sell for {gold}",
  "{key} · Rango {rank}/{max}": "{key} · Rank {rank}/{max}",
  "{kills} asesinatos": "{kills} kills",
  "{mode} contra bots": "{mode} vs bots",
  "{name} (tú)": "{name} (you)",
  "{name} aceptó tu solicitud de amistad": "{name} accepted your friend request",
  "{name} entró en la sala": "{name} joined the room",
  "{name} listo": "{name} ready",
  "{name} no está en línea": "{name} is not online",
  "{name} quiere ser tu amigo": "{name} wants to be your friend",
  "{name} salió de la sala": "{name} left the room",
  "{name} te invita a su sala": "{name} invites you to their room",
  "{name} y tú ya son amigos": "You and {name} are now friends",
  "{name} ya es tu amigo": "{name} is already your friend",
  "{name} · {online} de {total} en línea": "{name} · {online} of {total} online",
  "{rank} rango × {ad} AD": "{rank} rank × {ad} AD",
  "{size} líneas": "{size} lanes",
  "{size} · Tres líneas": "{size} · Three lanes",
  "{time} + {reach} u de alcance": "{time} + {reach} u reach",
  "{value} daño": "{value} damage",
  "¡Copiado!": "Copied!",
  "¡Cuenta creada! Bienvenido, {name}": "Account created! Welcome, {name}",
  "¡Enlace copiado!": "Link copied!",
  "¡Hola de nuevo, {name}!": "Welcome back, {name}!",
  "¡Nexo aliado destruido!": "Allied nexus destroyed!",
  "¡Nexo enemigo destruido!": "Enemy nexus destroyed!",
  "¡Nivel {level}!": "Level {level}!",
  "¡Torre aliada destruida!": "Allied tower destroyed!",
  "¡Torre enemiga destruida!": "Enemy tower destroyed!",
  "¡Victoria!": "Victory!",
  "¿Cerrar sesión? Seguirás jugando como invitado.": "Log out? You'll keep playing as a guest.",
  "¿Eliminar a {name} de tus amigos?": "Remove {name} from your friends?",
  "ÉPICO": "EPIC",
  "Épicos": "Epic",
  "Únete a mi sala de Melee MOBA": "Join my Melee MOBA room",
  "Único": "Unique",
  "← Volver": "← Back",
  "← VOLVER": "← BACK",
};
